import NomenclatureListPage from "../../../common/nomenclatures/NomenclatureListPage";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import {
  preReservationFormSchema,
  getPreReservationFormDefaults,
  IPreReservationFormInputModel,
} from "./models/preReservationFormInputModel";
import { PreReservationFormListItem } from "./components/PreReservationFormListItem";
import { PreReservationFormFormFields } from "./components/PreReservationFormFormFields";

export const PreReservationFormNomenclature = () => {
  return (
    <NomenclatureListPage<
      IPreReservationFormInputModel,
      IPreReservationFormInputModel
    >
      endpoints={endpointsMetadata.preReservationFormNomenclature}
      title="Форми"
      description="Формуляри, които потребителите попълват и приемат преди резервация."
      dialogAddTitle="Добавяне на форма"
      dialogEditTitle="Редактиране на форма"
      emptyListText="Няма създадени форми."
      itemTemplate={(item, index, isLoading, actionButtons, className) => (
        <PreReservationFormListItem
          item={item}
          isLoading={isLoading}
          actionButtons={actionButtons}
          className={className}
        />
      )}
      formSchema={preReservationFormSchema}
      defaultValues={() => getPreReservationFormDefaults()}
      formFields={<PreReservationFormFormFields />}
      editOnRowClick
    />
  );
};
